import { render, staticRenderFns } from "./PageDate.vue?vue&type=template&id=3c0b6cca&scoped=true&"
import script from "./PageDate.vue?vue&type=script&lang=js&"
export * from "./PageDate.vue?vue&type=script&lang=js&"
import style0 from "./PageDate.vue?vue&type=style&index=0&id=3c0b6cca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0b6cca",
  null
  
)

export default component.exports